
    // IMPORTS
    import { defineComponent } from 'vue'
    import { Button } from '@progress/kendo-vue-buttons'

    export default defineComponent({
        name: 'closeButtonHeader',

        components: {
            'k-button': Button,
        },

        props: {
            background: { type: Boolean, required: false, default: false },
        },

        emits: ['close'],
    });
